import { memo } from 'react';
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';
import { useDispatch, useSelector } from 'react-redux';
import { ContentDispatchActions } from 'src/redux/actions';
import { Button, Element, Icon } from 'src/components';
import { isLargeFontSize } from 'src/selectors/content';

export const ChangeSizeButton = () => {
    const dispatch = useDispatch();
    const isLargeFont = useSelector(isLargeFontSize);

    const handleClick = () => {
        dispatch(ContentDispatchActions.toggleFontSize());
    };

    return (
        <Button
            title="Cỡ chữ"
            className={cn(
                'px-[15px]',
                'flex items-center',
                'w-full',
                'text-left',
                'text-[16px] py-[12px]',
                'leading-[1]',
            )}
        >
            <Icon
                className={cn(
                    'flex justify-center',
                    'w-[36px]',
                    'text-[28px]',
                    'mr-[10px]',
                    'text-black',
                )}
                icon="new-textsize-regular"
            ></Icon>
            <span>Cỡ chữ</span>
            <Element
                className={twMerge(
                    'btn-switch',
                    'ml-auto h-[30px] w-[71px]',
                    'bg-transparent',
                    "bg-[url('https://baomoi-static.bmcdn.me/mobile/styles/img/bm-icon-2.0.3.png')]",
                    'bg-[length:100px_4250px] bg-no-repeat bg-[0_-2820px]',
                    cn({
                        ['bg-[0_-2880px]']: isLargeFont,
                    }),
                )}
                onClick={handleClick}
            ></Element>
        </Button>
    );
};

export default memo(ChangeSizeButton);
